import React from 'react';
import { PageHero } from '../components/PageHero';
import { LocationCard } from '../components/LocationCard';
import { LOCATIONS } from '../data/locations';
const HERO_IMAGE = 'https://cdn.magicpatterns.com/patterns/generated-images/a48b4252-372c-4a0d-a014-aacfbcc2a091.jpg';
export function Locations() {
  return <main className="w-full bg-ink-950" data-id="element-349" data-mp="27kqi6iic0c6f">
      <PageHero image={HERO_IMAGE} eyebrow="Nine Locations" title="Our Locations" accent="Locations" subtitle="Find a Me Time location near you. The same unhurried experience at every venue." note="Relaxing Asian-style massage inspired by traditional techniques from across East and Southeast Asia." data-id="element-350" data-mp="27huiopqu5ffv" />
      <section aria-label="All locations" className="glow-warm w-full bg-ink-950" data-id="element-351" data-mp="1os4ni1j5urnf">
        <div className="mx-auto grid w-full max-w-7xl gap-6 px-5 py-24 sm:grid-cols-2 sm:px-8 lg:grid-cols-3" data-id="element-352" data-mp="112tl6fm5wp76">
          {LOCATIONS.map((location, i) => <LocationCard key={location.slug} location={location} index={i} data-id="element-353" data-mp="w2o05iaee0y2" data-mpi={i} />)}
        </div>
      </section>
    </main>;
}